/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bsu_medium'
export default icon
